import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

interface WidgetContainerProps {
  backgroundColor?: string;
}

const DEFAULT_BACKGROUND = `linear-gradient(284.05deg, ${palette.lightTeal} 6.33%, rgba(162, 209, 208, 0) 37.56%),
    linear-gradient(97.97deg, ${palette.lightTeal} 1.16%, rgba(162, 209, 208, 0) 56.14%),
    linear-gradient(0deg, #D5F0F0, #D5F0F0)`;

export const WidgetContainer = styled.div<WidgetContainerProps>`
  max-width: 1280px;
  box-sizing: border-box;
  background: ${(props) => props.backgroundColor || DEFAULT_BACKGROUND};
  border-radius: 1rem;
  padding: 4.375rem 2rem;
  display: grid;
  row-gap: 1.7rem;
  margin: 0 auto;

  @media all and (max-width: ${layout.sm}) {
    padding: 2rem 1.5rem;
  }
`;

export const WidgetTitleSection = styled.div`
  display: grid;
  row-gap: 1.7rem;
  margin: 0 auto;

  // Resource Center's styles for Text Types can conflict with Embedded components, so we need to override them here
  // TODO: Define a more controlled way to exclude styles from Resource Center templates to not affect dynamic components
  > h1.widget-title {
    font-size: 3.375rem;

    @media all and (max-width: ${layout.sm}) {
      font-size: 2.125rem;
    }
  }
  > p.widget-description {
    font-size: 1.125rem;
    line-height: 1.5em;
    max-width: 750px;
    margin: 0 auto;

    @media all and (max-width: ${layout.sm}) {
      font-size: 1rem;
    }
  }
`;

export const InputSectionContainer = styled.div`
  max-width: 750px;
  margin: 0 auto;

  > button {
    display: none;
  }

  > p.widget-helper-text {
    font-size: 0.875rem;
    margin-top: 0.5rem;

    @media all and (max-width: ${layout.sm}) {
      font-size: 0.625rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    display: grid;
    grid-row-gap: 1rem;

    > button {
      display: flex;
      justify-content: center;
    }
  }
`;

export const InputWrapper = styled.div`
  height: 66px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem 0 1.75rem;
  background: ${palette.white};
  border: 1px solid ${palette.greyText};
  border-radius: 40px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > button {
    @media screen and (max-width: ${layout.sm}) {
      display: none;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 1rem;
    height: 50px;
  }
`;

export const Input = styled.input`
  text-align: left;
  background: ${palette.white};
  font-size: 1.1em;
  width: 100%;
  height: 100%;
  border: 0;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${palette.lightGrayBright};
  }

  @media screen and (max-width: ${layout.sm}) {
    font-size: 1rem;
  }
`;

export const DisclaimerSection = styled.div`
  display: grid;
  justify-self: center;
  max-width: 474px;

  > p.widget-disclaimer {
    font-size: 0.75rem;
    line-height: 1.6em;

    a {
      color: inherit;
      text-decoration: underline;
    }
  }
`;

interface PaperAirplaneButtonProps {
  backgroundColor?: string;
  borderColor?: string;
}

export const PaperAirplaneButton = styled.button<PaperAirplaneButtonProps>`
  background: ${(props) => props.backgroundColor || palette.accentBlue};
  border: 1px solid ${(props) => props.borderColor || palette.accentBlue};
  cursor: pointer;
  height: 50px;
  width: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 1.7rem;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  border-radius: 40px;

  @media screen and (max-width: ${layout.sm}) {
    display: none;
  }

  > p {
    font-weight: 400;
    margin-right: 0.625rem;
  }
`;
